import React, { useState } from 'react';
import axios from 'axios';
import { X, ArrowRight, CheckCircle2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PLANS = [
  { id: 'full', label: 'Pay in Full', price: '5,497 NIS', sub: 'Best price · one-time payment', total: '5,497 NIS' },
  { id: '3pay', label: '3 Monthly Payments', price: '1,899 NIS/mo', sub: 'Split across 3 months', total: '5,697 NIS total' },
  { id: '6pay', label: '6 Monthly Payments', price: '999 NIS/mo', sub: 'Easiest monthly commitment', total: '5,994 NIS total' },
];

const MomshiachMethodCheckout = ({ initialPlan = 'full', onClose }) => {
  const [plan, setPlan] = useState(initialPlan);
  const [form, setForm] = useState({ firstName: '', lastName: '', email: '', phone: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const isPayPal = plan !== 'full';
  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.firstName.trim() || !form.email.trim()) {
      setError('Please share your name and email.');
      return;
    }
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/checkout/momshiach-method`, {
        ...form,
        plan,
        origin_url: window.location.origin,
      });
      window.location.href = data.url;
    } catch (err) {
      setError(err.response?.data?.detail || 'Something went wrong. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="mm-modal-overlay" onClick={onClose} data-testid="mm-checkout-modal">
      <div className="mm-modal" onClick={(e) => e.stopPropagation()}>
        <button className="mm-modal-close" onClick={onClose} aria-label="Close" data-testid="mm-close-btn">
          <X size={20} />
        </button>
        <div className="mm-modal-header">
          <span className="mm-modal-eyebrow">The Momshiach Method™</span>
          <h2>Claim your spot</h2>
          <p>A few details, then PayPal takes it from here. Your first session invitation lands in your inbox within 24 hours.</p>
        </div>

        <form onSubmit={submit} className="mm-modal-form">
          <div className="mm-plan-picker" role="radiogroup" aria-label="Choose your payment plan">
            {PLANS.map((p) => (
              <label
                key={p.id}
                className={`mm-plan-option ${plan === p.id ? 'active' : ''}`}
                data-testid={`mm-plan-${p.id}`}
              >
                <input
                  type="radio"
                  name="plan"
                  value={p.id}
                  checked={plan === p.id}
                  onChange={() => setPlan(p.id)}
                />
                <div className="mm-plan-content">
                  <div className="mm-plan-title-row">
                    <span className="mm-plan-title">{p.label}</span>
                    {plan === p.id && <CheckCircle2 size={16} />}
                  </div>
                  <div className="mm-plan-price">{p.price}</div>
                  <div className="mm-plan-sub">{p.sub}</div>
                  <div className="mm-plan-total">{p.total}</div>
                </div>
              </label>
            ))}
          </div>

          <div className="mm-form-grid">
            <input
              type="text"
              placeholder="First name*"
              value={form.firstName}
              onChange={update('firstName')}
              required
              data-testid="mm-firstname-input"
            />
            <input
              type="text"
              placeholder="Last name"
              value={form.lastName}
              onChange={update('lastName')}
              data-testid="mm-lastname-input"
            />
            <input
              type="email"
              placeholder="Email*"
              value={form.email}
              onChange={update('email')}
              required
              className="mm-full"
              data-testid="mm-email-input"
            />
            <input
              type="tel"
              placeholder="WhatsApp / phone (optional)"
              value={form.phone}
              onChange={update('phone')}
              className="mm-full"
              data-testid="mm-phone-input"
            />
          </div>

          {error && <div className="mm-error" data-testid="mm-error">{error}</div>}

          <button
            type="submit"
            className="btn-primary btn-lg mm-submit"
            disabled={loading}
            data-testid="mm-submit-btn"
          >
            <span>{loading ? 'Sending you to checkout…' : 'Continue to PayPal'}</span>
            {!loading && <ArrowRight size={18} />}
          </button>

          <p className="mm-legal" data-testid="mm-legal-text">
            {isPayPal
              ? `Secure monthly billing via PayPal: your card or PayPal account is charged automatically each month and stops after the final payment. `
              : 'Secure payment via PayPal: pay by card or with your PayPal account. '}You&apos;ll receive a welcome email from Chanah within 24 hours to schedule your first session.
          </p>
        </form>
      </div>
    </div>
  );
};

export default MomshiachMethodCheckout;
